"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutreachInfoService = void 0;
class OutreachInfoService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get all supported sendgrid variables
     * @returns GetSupportedSendgridVariablesResponse
     * @throws ApiError
     */
    getSupportedSendgridVariables() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach-info/variables',
        });
    }
    /**
     * Get all supported outreach languages
     * @returns GetSupportedLanguagesResponse
     * @throws ApiError
     */
    getSupportedOutreachLanguages() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach-info/languages',
        });
    }
    /**
     * Get all supported outreach stages
     * @returns GetSupportedOutreachStagesResponse
     * @throws ApiError
     */
    getSupportedOutreachStages() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach-info/stages',
        });
    }
    /**
     * Get all supported outreach recipient
     * @returns GetSupportedOutreachRecipientsResponse
     * @throws ApiError
     */
    getSupportedOutreachRecipients() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach-info/recipient',
        });
    }
    /**
     * Get email preview templates
     * @param names
     * @returns GetEmailTemplatesResponse
     * @throws ApiError
     */
    getEmailPreviewTemplates(names) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach-info/email-preview',
            query: {
                'names': names,
            },
        });
    }
    /**
     * Send template emails in bulk
     * @param requestBody SendBulkEmailTemplatesPayload
     * @returns SendEmailBulkTemplatesResponse
     * @throws ApiError
     */
    sendEmailBulkTemplates(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/outreach-info/emails-bulk-templates',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get email settings
     * @param page
     * @param count
     * @returns GetEmailSettingsResponse
     * @throws ApiError
     */
    getEmailSettings(page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach-info/email-settings',
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Get and email setting by id
     * @param emailSettingId
     * @returns SingleEmailSettingResponse
     * @throws ApiError
     */
    getEmailSettingById(emailSettingId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach-info/email-setting/{emailSettingId}',
            path: {
                'emailSettingId': emailSettingId,
            },
        });
    }
    /**
     * Update an email setting by id
     * @param emailSettingId
     * @param requestBody
     * @returns SingleEmailSettingResponse
     * @throws ApiError
     */
    updateEmailSetting(emailSettingId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/outreach-info/email-setting/{emailSettingId}',
            path: {
                'emailSettingId': emailSettingId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update an email setting by id
     * @param emailSettingId
     * @returns any Successful response
     * @throws ApiError
     */
    deleteEmailSetting(emailSettingId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/outreach-info/email-setting/{emailSettingId}',
            path: {
                'emailSettingId': emailSettingId,
            },
        });
    }
    /**
     * Create an email setting
     * @param requestBody
     * @returns SingleEmailSettingResponse
     * @throws ApiError
     */
    createEmailSetting(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/outreach-info/email-setting',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.OutreachInfoService = OutreachInfoService;
